import Button from "components/ui/Button";
import InputDatePicker from "components/ui/forms/InputDatePicker";
import InputField from "components/ui/forms/InputField";
import InputSelect from "components/ui/forms/InputSelect";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const BonusHistoryFilters = ({ setSelectedFilters, handleFilters }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    //console.log(data);
    handleFilters(data);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const CATEGORY_OPTIONS = [
    { value: "sport", label: "Sport" },
    { value: "casino", label: "Casino" },
  ];
  const PERIOD_OPTIONS = [
    { value: "24", label: "24 hours" },
    { value: "72", label: "72 hours" },
    { value: "oneWeek", label: "One week" },
    { value: "oneMonth", label: "30 Days" },
    { value: "custom", label: "Custom" },
  ];

  useEffect(() => {
    setValue("category", CATEGORY_OPTIONS[0]);
    setValue("period", PERIOD_OPTIONS[0]);
    setSelectedFilters(getValues());
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <div className="md:flex gap-2 md:space-y-0 space-y-1">
        <InputSelect
          label="Category"
          name="category"
          options={CATEGORY_OPTIONS}
          control={control}
          {...register("category")}
        />
        <InputSelect
          label="Period"
          name="period"
          options={PERIOD_OPTIONS}
          control={control}
          {...register("period")}
        />
      </div>
      <div className="pt-5">
        <Button
          label={isLoading ? "Logging in..." : "Show"}
          type="submit"
          size="small"
          variant="green"
          className="uppercase md:max-w-[250px] w-full ml-auto"
        />
      </div>
    </form>
  );
};

export default BonusHistoryFilters;
